import React from 'react';

import AuthenticatedUserView from 'refactored/ui/views/authenticatedUserView';

const UtmCampaign = () => <AuthenticatedUserView />;

export default UtmCampaign;
